export const queryCacheConfig = {
  // Dados considerados fescos por 5 minutos
  // staleTime: 300000, // 5 minutes

  // Dados permanecerão no cache por 5 minutos
  // cacheTime: 300000, // 5 minutes

  // Evitar refetch automático uqando a janela ganhar foco
  refetchOnWindowFocus: false,

  // Evitar refetch automático quando a aplicação for re-focada ou re-renderizada
  refetchOnReconnect: false,

  // Evitar refetch automático quando o componente fo re-renderizado
  refetchIntervalInBackground: false,

  // Evitar re-tentativas em caso de erro na requisição
  retry: false,
}

export const queryNoCacheConfig = {
  // Evitar refetch automático uqando a janela ganhar foco
  refetchOnWindowFocus: false,

  // Evitar refetch automático quando a aplicação for re-focada ou re-renderizada
  refetchOnReconnect: false,

  // Evitar refetch automático quando o componente fo re-renderizado
  refetchIntervalInBackground: false,

  // Evitar re-tentativas em caso de erro na requisição
  retry: false,
}
